// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { useQuery } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { QueryConfig } from '@/lib/react-query';

const getPartnersUnpaidBills = async ({
  partnerIds,
  makeRequest,
}: {
  partnerIds?: string[];
  makeRequest: any;
}): Promise<any> => {
  const { data, error } = await makeRequest({
    path: `/partners/sylob/unpaid-bills`,
    method: 'POST',
    body: { partner_ids: partnerIds },
  });

  if (error) {
    throw new Error(error);
  }

  return data.unpaid_bills.reduce(
    (
      acc: any,
      activity: { partner_id: string; has_unpaid_bills: boolean }
    ) => ({
      ...acc,
      [activity.partner_id]: {
        has_unpaid_bills: activity.has_unpaid_bills,
      },
    }),
    {}
  );
};

type QueryFnType = typeof getPartnersUnpaidBills;

type UsePartnerActivityOptions = {
  config?: QueryConfig<QueryFnType>;
  partnerIds: string[];
};

export const useGetPartnersUnpaidBills = ({
  config,
  partnerIds,
}: UsePartnerActivityOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery({
    ...config,
    queryKey: ['partners', partnerIds, 'unpaidBills'],
    queryFn: () => getPartnersUnpaidBills({ partnerIds, makeRequest }),
  });
};
